var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{staticClass:"is-flex is-align-center",attrs:{"span":24}},[_c('div',{staticClass:"ra-back",on:{"click":_vm.back}},[_c('i',{staticClass:"ra-icon--arrow-left"})]),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._v(_vm._s(_vm.subheading))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }